import React from "react";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import InfoArea from "components/InfoArea/InfoArea.js";

// @material-ui icons
import Apps from "@material-ui/icons/Apps";
import ViewDay from "@material-ui/icons/ViewDay";
import ViewCarousel from "@material-ui/icons/ViewCarousel";
import Email from "@material-ui/icons/Email";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import People from '@material-ui/icons/People';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Timeline from "@material-ui/icons/Timeline";
import Code from "@material-ui/icons/Code";
import Group from "@material-ui/icons/Group";
import GifIcon from '@material-ui/icons/Gif';
import OndemandVideoIcon from '@material-ui/icons/OndemandVideo';
import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import descriptionStyle from "assets/jss/material-kit-pro-react/views/presentationSections/descriptionStyle.js";
import intl from 'react-intl-universal';



const useStyles = makeStyles(descriptionStyle);

export default function WelcomeDescription() {
	const classes = useStyles();
	return (
		<div className={classes.section} id={'WelcomeDescription'}>
			<div className={classes.container}>
				<GridContainer justify="center">
					<GridItem md={8} sm={8}>
						<h4 className={classes.description} style={{color: '#000'}}>
							<b>RobinAlgo</b>{intl.get('welcome_desc_1')}
						</h4>
					</GridItem>
				</GridContainer>
				<div className={classes.features}>
					<GridContainer>
						<GridItem md={4} sm={4}>
							<InfoArea
								title={intl.get('algorithm_animation')}
								description={
									<div style={{color: '#000'}}>
										{intl.get('welcome_desc_2')}
									</div>
								}
								icon={GifIcon}
								iconColor="danger"
								vertical={true}
							/>
						</GridItem>
						<GridItem md={4} sm={4}>
							<InfoArea
								title={intl.get('streamline_video')}
								description={
									<div style={{color: '#000'}}>
										{intl.get('welcome_desc_3')}
									</div>
								}
								icon={OndemandVideoIcon}
								iconColor="primary"
								vertical={true}
							/>
						</GridItem>
						<GridItem md={4} sm={4}>
							<InfoArea
								title={intl.get('code_comments')}
								description={
									<div style={{color: '#000'}}>
										{intl.get('welcome_desc_4')}
									</div>
								}
								icon={Code}
								iconColor="success"
								vertical={true}
							/>
						</GridItem>
					</GridContainer>
				</div>
			</div>
		</div>
	);
}
